import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/amjlogo.png'


const _hoisted_1 = { style: {"display":"flex","align-items":"center !important"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"2.5rem !important"},
  src: _imports_0
}, null, -1)
const _hoisted_3 = {
  style: {"margin-left":"10px","color":"white","font-weight":"500"},
  class: "title"
}
const _hoisted_4 = {
  key: 0,
  style: {"color":"orange","border":"2px solid","padding":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (!_ctx.$route.meta.layoutPlain)
    ? (_openBlock(), _createBlock(_component_v_app, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, {
            app: "",
            "clipped-left": "",
            color: "black",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, { class: "mr-12 align-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("span", _hoisted_3, [
                      _createTextVNode(" AMJ Deutschland Portal "),
                      (_ctx.testEnv)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " TEST "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.logout,
                to: "/",
                style: {"border-radius":"0px"},
                depressed: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Logout " + _toDisplayString(_ctx.username), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_ctx.$route.meta.layoutPlain)
      ? (_openBlock(), _createBlock(_component_v_app, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}